import { useState } from "react";
import api from "../../api";

interface AgolCheckProps {
  layerLabel: string;
  testEndpoint: string; // e.g. "/test-spray-layers"
  payload?: Record<string, unknown>;
}

type Status = "idle" | "testing" | "ok" | "error";

// Reusable AGOL connectivity check placed before any AGOL action.
export default function AgolCheck({ layerLabel, testEndpoint, payload }: AgolCheckProps) {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const runTest = async () => {
    setStatus("testing");
    try {
      const res = await api.post(testEndpoint, payload || {});
      setStatus("ok");
      setMessage(res.data?.message || "Accessible · feature service reachable");
    } catch (err: any) {
      setStatus("error");
      setMessage(err?.response?.data?.error || err?.message || "Connection failed");
    }
  };

  return (
    <div className="border border-line rounded-sm2 bg-paper px-4 py-3 mb-4 flex flex-wrap items-center gap-3">
      <span className={`w-2.5 h-2.5 rounded-full ${status === "ok" ? "bg-brand" : status === "error" ? "bg-wnv" : "bg-ink-faint"}`} />
      <span className="eyebrow">AGOL</span>
      <span className="font-mono text-xs bg-paper-2 border border-line rounded px-2 py-0.5">{layerLabel}</span>
      <button onClick={runTest} disabled={status === "testing"} className="btn-ghost !py-1 !px-3 text-xs ml-auto">
        {status === "testing" ? "Checking…" : "Test layer access"}
      </button>
      {status === "ok" && <span className="text-brand-deep text-xs font-semibold w-full">✓ {message}</span>}
      {status === "error" && <span className="text-wnv text-xs font-semibold w-full">✗ {message}</span>}
    </div>
  );
}
